import { api } from './client';

function isPlainObject(value: unknown): value is Record<string, unknown> {
  return value != null && typeof value === 'object' && !Array.isArray(value);
}

// A useQuery caller declares statuses it handles itself via `meta: { expectedStatuses: [404] }`,
// which is the only channel a read hook has to reach the fetch layer's Sentry reporting.
function readExpectedStatuses(meta: Record<string, unknown> | undefined): number[] | undefined {
  const value = meta?.expectedStatuses;
  if (Array.isArray(value) && value.every(item => typeof item === 'number')) {
    return value;
  }
  return undefined;
}

export async function defaultQueryFn({
  queryKey,
  signal,
  meta,
}: {
  queryKey: readonly unknown[];
  signal?: AbortSignal;
  meta?: Record<string, unknown>;
}) {
  const last = queryKey.at(-1);
  const hasParams = isPlainObject(last);
  const segments = hasParams ? queryKey.slice(0, -1) : queryKey;
  const params = hasParams ? last : undefined;
  if (segments.some(s => s == null)) {
    throw new Error(`queryKey contains null/undefined segments: [${queryKey.join(', ')}]`);
  }
  const path = segments.map(String).join('/');
  const { data } = await api.get(path, params, {
    signal,
    fromReactQuery: true,
    expectedStatuses: readExpectedStatuses(meta),
  });
  return data;
}
